import React from 'react';
import './Cards.css';
import './Button.css';
import { Button }  from './Button';



function Cards2() {

  const scrollToBottom = () => window.scrollTo({
    top: 500,
    behavior: "smooth"
  });
  return (
    <div className='cards'>
      <div style={{textAlign:'center'}}>
        <a className='itaclogo' href='https://indigenoustourism.ca/'>
          <img alt='ITAC Logo' src="images/itac-logo-fr-en.png"></img>
        </a>
      </div>
      <div style={{margin:'auto', width:'70%'}}><h2>Introduction: </h2>
      <h3><br></br>L’Association touristique autochtone du Canada (ATAC) s’est associée à iTOTEM Analytics pour
évaluer les bénéfices économiques et les retombées sociales d’investir dans l’infrastructure
touristique autochtone.
      <div><br></br>Les résultats de cette initiative qui s’inscrit dans le plan stratégique de relance et la vision de l’ATAC
pour l’industrie constitueront un apport inestimable aux efforts de plaidoyer de l’ATAC en faveur de
plus d’investissements et de programmes de soutien pour les opérateurs touristiques autochtones
entre 2022 et 2024. Les informations recueillies serviront à orienter le plan d’action. Elles feront
ressortir comment l’industrie touristique autochtone a prospéré de manière durable dans le passé et
permettront de mieux guider les ajustements nécessaires pour se remettre sur la bonne voie.</div>
<div><br></br>
Remarque : À des fins d'intégration des données, les champs de saisie ne peuvent pas inclure de virgule ou de signe dollar. Lorsqu'une
question demande un montant monétaire, veuillez entrer l'entier associé et assurez-vous que le nombre de zéros est correct (c'est-à-dire
entrez 10000 pour 10 000 $).</div>
      </h3></div>
      <div style={{margin:'auto'}}><br></br>
      <iframe 
            name="ITAC Form" 
            width="1300px"
            height="9000px" 
            frameborder="0"
            margin='auto' 
            marginheight="0" 
            marginwidth="0"
            // scrolling='no'
            title="Survey" 
            src="https://ee.kobotoolbox.org/x/JTpU9h9a?lang=fr"
            >
      </iframe>
      </div>
      <div style={{margin:'auto', width:'70%', textAlign:'center'}}>Après avoir appuyé sur le bouton Enregistrer le brouillon, faites défiler vers le haut pour confirmer
        <div className='hero-btns' style={{textAlign:'center'}}>
          <br></br>
          <div></div>
          <Button
            style={{margin:'auto', width:'70%'}}
            className='btns'
            buttonStyle='btn--outline-black'
            buttonSize='btn--large'
            onClick = {scrollToBottom}
          >
            Aller en haut
          </Button>
        </div>
      </div>

    </div>
  );
}

export default Cards2;
